var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchliesskreuz02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Schliesskreuz-02__Icn/40px/Schliesskreuz-02",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,10 C25.5228475,10 30,14.4771525 30,20 C30,25.5228475 25.5228475,30 20,30 C14.4771525,30 10,25.5228475 10,20 C10,14.4771525 14.4771525,10 20,10 Z M20,12 C15.581722,12 12,15.581722 12,20 C12,24.418278 15.581722,28 20,28 C24.418278,28 28,24.418278 28,20 C28,15.581722 24.418278,12 20,12 Z M23.4852814,15 L24.8994949,16.4142136 L21.364,19.95 L24.8994949,23.4852814 L23.4852814,24.8994949 L19.95,21.364 L16.4142136,24.8994949 L15,23.4852814 L18.536,19.95 L15,16.4142136 L16.4142136,15 L19.95,18.536 L23.4852814,15 Z",
    id: ".._.._src_svg_Icn_40px_Schliesskreuz-02__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchliesskreuz02);
export default __webpack_public_path__ + "static/media/Schliesskreuz-02.388774511e5af67c70ba4ae174a647d7.svg";
export { ForwardRef as ReactComponent };